















































































































































































































































































































































































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { staffList, getSelectCourseList } from "@/api/globalSearch";
import teacherAndStudentDetail from "./teacherAndStudentDetail.vue";
import {
  relationStudentListApi,
  relationStudentStatisticsApi,
  relationStudentListInter,
  relationStudentListStatisticsApi,
} from "@/api/teacherManage";
import {
  dateFormat,
  getCurrentWeek,
  getCurrentMonth,
} from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import { mixin } from "@/mixin/tabPageInfoMixin";
import associateStudents from "./associateStudents.vue";
import relieveAssociate from "./relieveAssociate.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "teacherAndStudentInfo",
  components: {
    teacherAndStudentDetail,
    associateStudents,
    relieveAssociate,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo = {
    teacher_id: "",
    teacher_list: [],
    student_key_word: "",
    current_status: -1,
    teach_status: -1,
    roll_call_time: [],
    admin_time: [],
    sort_type: "desc",
    sort_field: "",
    course_id: "",
    student_type: -1,
    stop_type: [],
  };
  teacherInfo = {
    week: {},
    month: {},
  };
  teacherName = "";
  teacherMobile = "";
  classTotal = {};
  tableData = [];
  dialogTableVisible = false;
  page = 1;
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 0;
  courseList: any[] = [];
  startWeekTime: string = ""; // 本周开始时间
  endWeekTime: string = ""; // 本周结算时间
  startMonthTime: string = ""; // 本月开始时间
  endMonthTime: string = ""; // 本月结束时间
  suspendClassList: any[] = [
    {
      suspendClass_id: 1,
      title: "正常",
    },
    {
      suspendClass_id: 2,
      title: "停课中",
    },
  ];
  created() {
    this.mixinGetPageInfo("teacherAndStudentInfo");
    this.getCourseList("");
    this.startWeekTime = dateFormat("YYYY-mm-dd", getCurrentWeek()[0]);
    this.endWeekTime = dateFormat("YYYY-mm-dd", getCurrentWeek()[1]);
    this.startMonthTime = dateFormat(
      "YYYY-mm-dd",
      getCurrentMonth(new Date())[0]
    );
    this.endMonthTime = dateFormat(
      "YYYY-mm-dd",
      getCurrentMonth(new Date())[1]
    );
    if (this.searchInfo.teacher_id) {
      this.handleTeacherChange();
    } else {
      this.handleSearchTeacher("");
    }
  }
  getCourseList(v: any) {
    getSelectCourseList({
      page: 1,
      page_size: 1000,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.courseList = res.data.list;
      }
    });
  }
  handleSearchTeacher(v: any) {
    staffList({
      page: 1,
      page_size: 100,
      key_word: v,
      job_ids: [1],
      status: 1,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.list && res.data.list[0]) {
          this.searchInfo.teacher_id = res.data.list[0].staff_id;
          this.handleTeacherChange();
        }
      }
    });
  }
  getTime(e: any, type: any) {
    if (type === 1) {
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format.slice(0, 10) + " " + format.slice(11);
    } else {
      const format = dateFormat("YYYY-mm-dd", e);
      return format.slice(0, 10);
    }
  }
  // search_type 页码和条目数不发起统计请求
  getList(params: relationStudentListInter, search_type: number) {
    params = {
      page: this.page,
      page_size: this.pageSize,
      teacher_id: Number(this.searchInfo.teacher_id),
    };
    if (this.searchInfo.student_key_word) {
      params.student_key_word = this.searchInfo.student_key_word;
    }
    if (this.searchInfo.current_status !== -1) {
      params.student_status = this.searchInfo.current_status;
    }
    if (this.searchInfo.teach_status !== -1) {
      params.grant_lesson_status = this.searchInfo.teach_status;
    }
    if (this.searchInfo.roll_call_time) {
      params.roll_call_start_time = this.searchInfo.roll_call_time[0];
      params.roll_call_end_time = this.searchInfo.roll_call_time[1];
    }
    if (this.searchInfo.admin_time) {
      params.admission_start_time = this.searchInfo.admin_time[0];
      params.admission_end_time = this.searchInfo.admin_time[1];
    }
    if (this.searchInfo.sort_type) {
      params.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field) {
      params.sort_field = this.searchInfo.sort_field;
    }
    if (this.searchInfo.course_id) {
      params.course_id = Number(this.searchInfo.course_id);
    }
    if (this.searchInfo.student_type > -1) {
      params.student_status = Number(this.searchInfo.student_type);
    }
    if (this.searchInfo.stop_type.length > 0) {
      params.stop_status = this.searchInfo.stop_type;
    }
    if (search_type === 1) {
      relationStudentListApi(params).then((res: any) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
      relationStudentListStatisticsApi(params).then((res: any) => {
        if (res.error_code === 0) {
          this.classTotal = res.data;
        }
      });
    } else {
      relationStudentListApi(params).then((res: any) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    }
  }
  handleSearch() {
    this.getList(
      {
        page: 1,
        page_size: 10,
        teacher_id: Number(this.searchInfo.teacher_id),
      },
      1
    );
    this.mixinSavePageInfo("teacherAndStudentInfo");
  }
  handleTeacherChange() {
    const id = Number(this.searchInfo.teacher_id);
    if (id) {
      relationStudentStatisticsApi({
        teacher_id: id,
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.teacherInfo = res.data;
          this.getList(
            {
              page: 1,
              page_size: 10,
              teacher_id: Number(this.searchInfo.teacher_id),
            },
            1
          );
        }
      });
    }
    this.mixinSavePageInfo("teacherAndStudentInfo");
  }
  clickSort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList(
      {
        page: 1,
        page_size: this.pageSize,
        teacher_id: Number(this.searchInfo.teacher_id),
      },
      2
    );
  }
  goStudentDetail(sid: any) {
    this.$router.push({
      name: "studyDetails",
      query: {
        id: sid,
      },
    });
    this.mixinSavePageInfo("teacherAndStudentInfo");
  }
  goRollCallStudent(route_name: string, time: string, route_type: string) {
    if (time === "week") {
      const newPage = this.$router.resolve({
        name: route_name,
        query: {
          name: time,
          tid: this.searchInfo.teacher_id,
          s_time: this.startWeekTime,
          e_time: this.endWeekTime,
          route_type: route_type,
        },
      });
      window.open(newPage.href, "_blank");
    }
    if (time === "month") {
      const newPage = this.$router.resolve({
        name: route_name,
        query: {
          name: time,
          tid: this.searchInfo.teacher_id,
          s_time: this.startMonthTime,
          e_time: this.endMonthTime,
          route_type: route_type,
        },
      });
      window.open(newPage.href, "_blank");
    }
    if (time === "all") {
      const newPage = this.$router.resolve({
        name: route_name,
        query: {
          name: time,
          tid: this.searchInfo.teacher_id,
          route_type: route_type,
        },
      });
      window.open(newPage.href, "_blank");
    }
  }
  jumpRollCallStudent(route_name: string, route_type: string, s_n: string) {
    const newPage = this.$router.resolve({
      name: route_name,
      query: {
        tid: this.searchInfo.teacher_id,
        route_type: route_type,
        ts_n: s_n,
      },
    });
    window.open(newPage.href, "_blank");
  }
  Jumps(route_name: string, class_people: string) {
    if (class_people === "2" || class_people === "1") {
      const newPage = this.$router.resolve({
        name: route_name,
        query: {
          t_s_id: this.searchInfo.teacher_id,
          cl_pe: class_people,
        },
      });
      window.open(newPage.href, "_blank");
      return;
    }
    const newPage = this.$router.resolve({
      name: route_name,
      query: {
        t_s_id: this.searchInfo.teacher_id,
      },
    });
    window.open(newPage.href, "_blank");
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getList(
      {
        page: e,
        page_size: this.pageSize,
        teacher_id: Number(this.searchInfo.teacher_id),
      },
      2
    );
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    // this.page = 1;
    this.getList(
      {
        page: 1,
        page_size: e,
        teacher_id: Number(this.searchInfo.teacher_id),
      },
      2
    );
  }
  relationSuccess() {
    this.getList(
      {
        page: 1,
        page_size: 10,
        teacher_id: Number(this.searchInfo.teacher_id),
      },
      1
    );
  }
}
